export default __webpack_public_path__ + "static/desktop-form1-f2634d34cafff004c772ab74155a8a3f.png";